import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { makeJpgUrl } from '../Contentful';
import { isContentfulImage } from '../utils';
import { useT } from '@mrkt/features/i18n';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BLOG_URL = '/blog.rss';
export var DEFAULT_SOCIAL_CARD = '/socialcard.jpg';
var LQAHead = styled.div.withConfig({
  displayName: "PageHead__LQAHead",
  componentId: "bplep1-0"
})([".metaDesc{display:block;content:'Charset: ' attr(charset);transform:translateX(25px);}[name][content]::after{content:attr(content);}"]);
export var PageHead = function PageHead(props) {
  var t = useT();
  var router = useRouter();
  var titleParts = typeof props.title === 'string' ? [props.title] : props.title;
  var title = [].concat(_toConsumableArray(titleParts.filter(Boolean)), [t('FRODOR_bfbc75', 'Spotify for Artists', '')]).join(' – ');
  var image = (props.image || DEFAULT_SOCIAL_CARD).replace(/^\/\//, 'https://');

  if (isContentfulImage(image)) {
    // contentful asset, convert to jpg
    image = makeJpgUrl(image);
  }

  var description;

  if (router.query && router.query._lqa === 'pageHead') {
    description = t('FRODOR_e7a647', 'Get more out of Spotify with tools & tips for artists and their teams.', '');
  } else {
    description = props.description || t('FRODOR_e7a647', 'Get more out of Spotify with tools & tips for artists and their teams.', '');
  }

  var linkedData = props.linkedData && _objectSpread({
    '@context': 'http://schema.org'
  }, props.linkedData); // these are only the dynamic elements of the head - static and default elements are written
  // in _document.tsx and overridden here


  return router.query && router.query._lqa === 'pageHead' ? /*#__PURE__*/_jsx(LQAHead, {
    children: /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description,
      className: "metaDesc"
    }, "meta.description")
  }) : /*#__PURE__*/_jsxs(Head, {
    children: [props.canonicalUrl && /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: props.canonicalUrl
    }), /*#__PURE__*/_jsx("title", {
      children: title
    }, "title"), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }, "meta.description"), /*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: title
    }, "meta.og:title"), /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: description
    }, "meta.og:description"), /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: image
    }, "meta.og:image"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/_jsx("meta", {
      property: "twitter:image",
      content: image
    }, "meta.twitter:image"), /*#__PURE__*/_jsx("meta", {
      property: "twitter:title",
      content: title
    }, "meta.twitter:title"), /*#__PURE__*/_jsx("meta", {
      property: "twitter:description",
      content: description
    }, "meta.twitter:description"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:site",
      content: "@spotifyartists"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:app:id:iphone",
      content: "324684580"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:app:id:googleplay",
      content: "com.spotify.music"
    }), /*#__PURE__*/_jsx("meta", {
      name: "apple-itunes-app",
      content: "app-id=1222021797"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:app:id:googleplay",
      content: "com.spotify.music"
    }), /*#__PURE__*/_jsx("link", {
      rel: "alternate",
      type: "application/rss+xml",
      title: t('FRODOR_3e864f', 'All Posts – News – Spotify for Artists', 'Posts mean blog post'),
      href: "".concat(router.locale ? "/".concat(router.locale) : '').concat(BLOG_URL)
    }, "link.blogUrl"), linkedData && /*#__PURE__*/_jsx("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(linkedData)
      }
    }, "script.linkedData"), props.children && props.children]
  });
};